import { assetActions } from '@bvt-features/tenant-suitability/store/asset/asset.slice';
import { useDispatch, useSelector } from 'react-redux';
import * as asyncAction from '@bvt-features/tenant-suitability/store/asset/asset.asyncAction';

export const useTenantSuitability = () => {
  const state = useSelector((state) => state.features.TENANT_SUITABILITY.asset);
  const dispatch = useDispatch();

  const resetState = () => dispatch(assetActions.resetState());

  /**
   *
   * @param {object} param
   * @param {'status_LIST_ASSET'|'status_DASHBOARD_RESULT'} param.type
   */
  const resetStatus = (param) =>
    dispatch(assetActions.resetStatus({ type: param.type }));

  const resetDashboard = () => dispatch(assetActions.resetDashboard());

  /**
   *
   * @param {object} param
   * @param {string} param.id
   */
  const setSelectedID = (param) => dispatch(assetActions.setSelectedID(param));

  /**
   *
   * @param {object} param
   * @param {string} param.img
   */
  const setSelectedImg = (param) =>
    dispatch(assetActions.setSelectedImg(param));

  /**
   *
   * @param {object} param
   * @param {object} param.coordinate
   * @param {string} param.coordinate.lat
   * @param {string} param.coordinate.lng
   */
  const setCoordinate = (param) => dispatch(assetActions.setCoordinate(param));

  const getListAsset = (param) => dispatch(asyncAction.getListAsset(param));

  const getDetailAsset = (param) => dispatch(asyncAction.getDetailAsset(param));

  const doDownloadAssetList = (param) =>
    dispatch(asyncAction.doDownloadAssetList(param));

  /**
   *
   * @param {boolean} param
   */
  const setStartDownload = (param) => {
    dispatch(assetActions.setStartDownload(param));
  };

  /**
   * @param {boolean} param
   */
  const setToggleStatus = (param) =>
    dispatch(assetActions.setToggleStatus(param));

  const resetDownload = () => dispatch(assetActions.resetDownload());

  /**
   * @param {object} params
   * @param {string} params.id
   * @param {string} params.lat
   * @param {string} params.long
   * @param {string} params.name
   * @param {string} params.address
   */
  const setEditData = (params) => dispatch(assetActions.setEditData(params));

  /**
   *
   * @param {object} param
   * @param {string} param.site_id
   * @param {string} param.name
   * @param {string} param.longitude
   * @param {string} param.latitude
   * @param {string} param.address
   */
  const addEditAsset = (param) => dispatch(asyncAction.createUpdateAsset(param));

  /**
   * @param {string} id
   */
  const deleteAsset = (id) => dispatch(asyncAction.doDeleteAsset(id));

  /**
   * @param {string} id
   */
  const getRukoList = (id) => dispatch(asyncAction.getRukoListDetail(id));

  /**
   * @param {string} id
   */
  const getTenantList = (id) => dispatch(asyncAction.getTenantListDetail(id));

  /**
   * @param {string} id
   */
  const getPOIList = (id) => dispatch(asyncAction.getPOIListDetail(id));

  const getStatusAnalysis = (param) => dispatch(asyncAction.getStatusAnalysisAsset(param));

  const getListKategori = () => dispatch(asyncAction.getKategoriList());

  const getNewTenants = () => dispatch(asyncAction.getNewTenantList());
  const deleteNewTenant = (id) => dispatch(asyncAction.removeNewTenant(id));
  const addNewTenant = (payload) => dispatch(asyncAction.createNewTenant(payload));

  /**
   * @param {object} param
   * @param {string} param.url
   * @param {string} param.filename
   * @param {string} param.status
   * @param {string} param.message
   */
  const doDownloadBulkResult = (param) => dispatch(asyncAction.bulkDownloadResult(param));

  /**
   * @param {boolean} param
   */
  const setShowDownload = (param) =>
    dispatch(assetActions.setShowDownload(param));

  const doBulkDownloadXls = (param) => dispatch(asyncAction.doDownloadBulkResultXls(param));

  /**
   * @param {boolean} param
   */
  const setLoadingDownload = (param) =>
    dispatch(assetActions.setLoadingDownload(param));

  /**
   * @param {string} param
   */
  const setDownloadFilename = (param) =>
    dispatch(assetActions.setDownloadFilename(param));
  return {
    setDownloadFilename,
    getListKategori,
    getStatusAnalysis,
    getPOIList,
    getTenantList,
    getRukoList,
    setEditData,
    deleteAsset,
    resetDownload,
    setStartDownload,
    doDownloadAssetList,
    doDownloadBulkResult,
    getListAsset,
    resetState,
    resetDashboard,
    resetStatus,
    getDetailAsset,
    setSelectedID,
    setSelectedImg,
    setCoordinate,
    addEditAsset,
    setToggleStatus,
    deleteNewTenant,
    addNewTenant,
    getNewTenants,
    setShowDownload,
    doBulkDownloadXls,
    setLoadingDownload,
    state,
  };
};
